import { AfterViewInit, Component, OnInit } from '@angular/core';
import { APIService } from 'src/app/api.service';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-validate-import-items',
  templateUrl: './validate-import-items.component.html',
  styleUrls: ['./validate-import-items.component.scss']
})

export class ValidateImportItemsComponent implements OnInit, AfterViewInit {

  itemType: any = [
    {
      id: 1,
      type: "Products"
    },
    {
      id: 2,
      type: "Materials"
    },
    {
      id: 3,
      type: "Spares"
    },
    {
      id: 4,
      type: "Assemblies"
    }
  ];
  
  purchaseTypes: any = [
    {
      id: 1,
      type: 'Make'
    },
    {
      id: 2,
      type: 'Purchase'
    },
    {
      id: 3,
      type: 'Both'
    },   
  ];

  importData: any = [];
  stores: any = [];
  itemCategories: any = [];
  units: any = [];
  itemData: any = [];
  items: any = [];
  itemErrors: any = [];
  jarvisData: any = [];
  agencyData: any = [];
  dataSource: any = [];
  errorElements: any = [];
  itemList: any = [];
  itemParamList: any = [];
  categoryNameList: Array<any> = [];
  subCategoryNameList: Array<any> = [];
  itemTypeList: Array<any> = [];
  purchTypeList: Array<any> = [];
  storeNameList: Array<any> = [];
  categoryList: Array<any> = [];
  catList: Array<any> = [];
  subCategoryList: Array<any> = [];
  storeList: Array<any> = [];
  unitList: Array<any> = [];
  erp_Agn: Array<any> = [];
  acctStartDT: any = new Date();
  hsnList: string = "";
  currentErrorPosition: number = 0;
  isWeb: boolean = true;
  isEnableBatches: boolean = false;
  showIgnoreErr: boolean = true;
  isPreviousDisabled: boolean = false;
  isNextDisabled: boolean = false;
  error: any = {
    showError: true,
    ignoreErrors: false,
    apiResponse: false
  };
  displayedColumns: string[] = ['No.', 'ItemName', 'Code', 'Category', 'SubCategory', 'Type', 'StdCost', 'PurchCost', 'StdSalePrice', 'InitialQty', 'Unit', 'Store', 'HSN_SAC', 'GST', 'Description', 'Source', 'LeadTime', 'MinStock', 'MRPPrice'];
  billableList: any = [];

  constructor(private apiService: APIService, public CmnService: CommonService, private modalService: NgbModal) { 

    this.isWeb = this.apiService.apiCheckWeb();

  }


  ngOnInit(): void {

    // get item type and purchase type list
    this.itemTypeList = this.itemType.map((itemType: any) => itemType.type);
    this.purchTypeList = this.purchaseTypes.map((purchType: any) => purchType.type);

    // get erp config data
    this.getErpCfgData();

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    this.apiService.getIDB('erp_inv', (itemData: any) => {
      if (itemData && itemData.length > 0) {
        this.itemData = itemData;
      }
    });

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.erp_Agn = JSON.parse(tmpERP_Agn);
    }

    if (this.erp_Agn.length > 0) {
      this.acctStartDT = new Date(this.erp_Agn[0].AccountStartDT);
      this.isEnableBatches = this.erp_Agn[0].EnblBatches;
    }

    let importData = localStorage.getItem("importItems");
    if (importData) {
      this.importData = JSON.parse(importData);
    }
   
    let cfgAgnCookie = localStorage.getItem("Cfg_AgnCfg");
    let cfgAgnData: any = [];
    
    if (cfgAgnCookie) {
      cfgAgnData = JSON.parse(cfgAgnCookie);
    }
    
    if (cfgAgnData.length > 0) {
      if (cfgAgnData[0].Billables) {
        this.billableList = JSON.parse(cfgAgnData[0].Billables);
        this.billableList = this.billableList.filter((s: any) => s.INm !== '' && s.INm !== undefined && s.IID === 0 && (s.TID === 3 || s?.ITyp === 'S') );
      }
    }

    let itemArrayLength = this.importData.length;
    let errorList : Array<any> = [];
    let errIDsToCheck = [1, 2, 3, 4, 5, 9, 11]; // (errID: errorName) 1: itemName, 2: Code, 3: category, 4: sub-category, 5: type, 9: initialQty, 11: store
    for (let i: number = 0; i < itemArrayLength; i++) {
      let subCategoryListName: Array<any> = [];

      let errIDArray = this.importData[i].errID;
      if (errIDArray.some((errID: number) => errIDsToCheck.includes(errID))) {
        this.showIgnoreErr = false;
      }

      if (this.categoryNameList.includes(this.importData[i]["Category"])) {
        this.subCategoryList = this.getSubCategories(this.importData[i]["Category"]);
        subCategoryListName = this.subCategoryList.map((sub: any) => sub.snm);
      }

      let currCtg = this.importData[i]["Category"] || "";
      let itemCtgs = this.categoryList;
      let isValidCtg = $.grep(itemCtgs, function(o: any){ return o.cnm.toLowerCase() == currCtg.toLowerCase()});
      let currCtgID = isValidCtg.length > 0 ? isValidCtg[0].cid : '0';

      errorList.push({
        srNo: i + 1,
        itemName: this.importData[i]["Item Name"],
        itemCode: this.importData[i]["Code"],
        category: this.categoryNameList.includes(this.importData[i]["Category"]) ? this.importData[i]["Category"] : '',
        CID: currCtgID,
        subCategory: subCategoryListName.includes(this.importData[i]["Sub-Category"]) ? this.importData[i]["Sub-Category"] : '',
        origSubCtg: this.importData[i]["Sub-Category"],
        type: this.itemTypeList.includes(this.importData[i]["Type"]) ? this.importData[i]["Type"] : '',
        stdCost: this.importData[i]["Std Cost"],
        purchCost: this.importData[i]["Purch Cost"],
        stdSalePrice: this.importData[i]["Std Sale Price"],
        initialQty: this.importData[i]["Initial Qty"],
        unit:  this.units.includes(this.importData[i]["Unit"]) ? this.importData[i]["Unit"] : '',
        store: this.storeNameList.includes(this.importData[i]["Store"]) ? this.importData[i]["Store"] : '',
        hsn: this.importData[i]["HSN/SAC"],
        gst: this.importData[i]["GST %"],
        desc: this.importData[i]["Description"],
        source: this.purchTypeList.includes(this.importData[i]["Source"]) ? this.importData[i]["Source"] : '',
        leadTime: this.importData[i]["Lead Time"],
        minStock: this.importData[i]["Min. Stock"],
        mrpPrice: this.importData[i]["MRP Price"],
        errID: this.importData[i].errID,
        errors: this.importData[i].errors,
      });
    }
    this.itemList = errorList;
    this.dataSource = new MatTableDataSource(this.itemList);
  }

  ngAfterViewInit(): void {
    this.errorElements = document.querySelectorAll('.error-border');
    if (this.errorElements.length > 0) {
      this.errorElements[this.currentErrorPosition].focus();
      this.updateButtonStates();
    }
  }

  goToPreviousErr() {
    this.errorElements = document.querySelectorAll('.error-border');
    if (this.isPreviousDisabled) { 
      return
    }
    else if (this.currentErrorPosition > 0) {
      this.currentErrorPosition--;
      this.errorElements[this.currentErrorPosition].focus();
      this.updateButtonStates();
    }
  }

  goToNextErr() {
    this.errorElements = document.querySelectorAll('.error-border');
    if (this.isNextDisabled) {
      return
    }
    else if (this.currentErrorPosition < this.errorElements.length - 1) {
      this.currentErrorPosition++;
      this.errorElements[this.currentErrorPosition].focus();
      this.updateButtonStates();
    }
  }

  updateButtonStates() {
    this.isPreviousDisabled = this.currentErrorPosition == 0;
    this.isNextDisabled = this.currentErrorPosition == this.errorElements.length - 1;
  }

  getErpCfgData () {
    var erpCfgCookie = this.apiService.getCookie("ERP_Cfg");
    if (erpCfgCookie) {
      let erpCfgData = JSON.parse(erpCfgCookie);
      
      // Get Store List
      this.stores = erpCfgData[0].Stores;
      this.storeList = JSON.parse(this.stores);
      this.storeList = this.storeList.sort((a: any, b: any) => a.sNm.localeCompare(b.sNm));
      this.storeNameList = this.storeList.map((store: any) => store.sNm);

      // Get HSN List
      let hsn = erpCfgData[0].HSNSAC;
      if (hsn.length > 0) {
        this.hsnList = hsn;
      } 

      //Get Item Categories
      this.itemCategories = erpCfgData[0].ItemCategories;
      this.categoryList = JSON.parse(this.itemCategories);
      this.catList = this.categoryList.sort((a: any, b: any) => a.cnm.localeCompare(b.cnm));
      this.categoryNameList = this.catList.map((cat: any) => cat.cnm);
      
      // Get Item UnitList
      this.units = erpCfgData[0].Units;
      this.unitList = JSON.parse(this.units);
      this.unitList = this.unitList.sort((a: any, b: any) => a.UNm.localeCompare(b.UNm));
      this.units = this.unitList.map((unit: any) => unit.UNm);
    }
  }

  // Reset subcategory when category changes
  onCategoryChange(item: any) {
    item.subCategory = '';
  }

  getSubCategories(categoryName: string) {
    let category = this.categoryList.find(cat => cat.cnm == categoryName);
    return category ? category.sub : [];
  }

  save() {
    this.itemParamList = this.itemList;
    this.error.showError = false;
    this.itemParamList.forEach((element: any) => {
      element.errID = [];
      element.errors = [];
    });
    this.checkitemValidation(this.itemParamList);
    if (!this.error.ignoreErrors) {
      if (this.itemErrors.length > 0) {
        this.error.showError = true;
        this.apiService.errorAlert("Please correct the errors before saving.");
      } else {
        this.error.ignoreErrors = true;
        this.saveBulkItems();
      }
    } else {
      this.saveBulkItems();
    }  
  }
  
  //checkitemValidation() - Check import items validation
  checkitemValidation(items: Array<any>){
    this.getErpCfgData();
    let errorList : Array<any> = [];
    let itmArraylength = items.length;
    let isCheckDup = [];
    let itemType: Array<any> = this.itemType;
    let purchaseTypes: Array<any> = this.purchaseTypes;

    //Cat-Sub Cat List
    let itemCategories: Array<any> = [];
    itemCategories = JSON.parse(this.itemCategories);

    // HSN List
    let hsnList: Array<any> = [];
    hsnList = JSON.parse(this.hsnList);

    let accountFinYear = this.CmnService.getCurrentFinancialYear(this.acctStartDT);
    let currFinYear = this.CmnService.getCurrentFinancialYear(new Date);

    //Validation
    items.forEach((e: any) => {    
      e.errID = []; //(ID: errorName) 1: itemName, 2: Code, 3: category, 4: sub-category, 5: type, 6: stdCost, 7: purchCost, 8: stdSalePrice, 9: initialQty, 10: unit, 11: store, 12: HSN/SAC, 13: GST, 14: Description, 15: Source, 16: leadTime, 17: minStock, 18: mrpPrice
      e.errors = [];

      //check if the value exists
      e.itemName = e.itemName || '';
      e.itemCode = e.itemCode || '';
      e.category = e.category || '';
      e.subCategory = e.subCategory || '';
      e.type = e.type || '';
      e.initialQty = e.initialQty || 0;
      e.unit = e.unit || '';
      e.store = e.store || '';
      e.stdCost = e.stdCost || '0';
      e.purchCost = e.purchCost || '0';
      e.stdSalePrice = e.stdSalePrice || '0';
      e.hsn = e.hsn || '';
      e.gst = e.gst || 0;
      e.desc = e.desc || '';
      e.source = e.source || '';
      e.leadTime = e.leadTime || 0;
      e.minStock = e.minStock || 0;
      e.mrpPrice = e.mrpPrice || 0;

      //Trim all the values
      e.itemName = String(e.itemName).trim();
      e.itemCode = String(e.itemCode).trim();
      e.store = String(e.store).trim();
      e.category = String(e.category).trim();
      e.subCategory = String(e.subCategory).trim();
      e.unit = String(e.unit).trim();
      e.type = String(e.type).trim();
      e.desc = String(e.desc).trim();

      if(e.itemName == '') {
        e.errID.push(1);
        e.errors.push({ errID: 1, errorMsg: 'Please enter an item name.' });
      }
      else if (e.itemName.length > 100) {
        e.errID.push(1);
        e.errors.push({ errID: 1, errorMsg: 'Please enter item name shorter than 100 characters.' });
      }
      else {
      	//Item Name Duplications in Excel
        isCheckDup = $.grep(items, function(o: any) { return o.itemName == e.itemName });
        if(isCheckDup.length > 1) {
            e.errID.push(1);
            e.errors.push({ errID: 1, errorMsg: 'Duplicate item name in uploaded sheet.' });
        }
        else {
          // Check Duplicate item in item List
          let isDup = this.itemData.filter((x: any) => x.ItemName == e.itemName)
          if(isDup.length > 0) {
            e.errID.push(1);
            e.errors.push({ errID: 1, errorMsg: 'Another item with this name already exists.' });
          }
        } 
        let nonstockItm = this.billableList.filter((x: any) => x.INm.trim() == e.itemName.trim())
        if(nonstockItm.length > 0){
          e.errID.push(1);
          e.errors.push({ errID: 1, errorMsg: 'Item with this name already exists in non-stock items.' });
        }


      }
      
      // Item Code Duplications in excel
      if(e.itemCode == '') {
        e.errID.push(2);
        e.errors.push({ errID: 2, errorMsg: 'Please enter an item code.' });
      }
      else if (e.itemCode.length > 50) {
        e.errID.push(2);
        e.errors.push({ errID: 2, errorMsg: 'Please enter item code shorter than 50 characters.' });
      }
      else{
        isCheckDup = [];
        isCheckDup = $.grep(items, function(o: any) { return o.itemCode == e.itemCode });
        if(isCheckDup.length > 1){
            e.errID.push(2);
            e.errors.push({ errID: 2, errorMsg: 'Duplicate item code in uploaded sheet.' });
        }
        else{
          // Check Duplicate item code in item List
          let isDup = this.itemData.filter((x: any) => x.ItemCode == e.itemCode)
          if(isDup.length > 0) {
            e.errID.push(2);
            e.errors.push({ errID: 2, errorMsg: 'Another item with this code already exists.' });
          }
        }         
      }
       
      //Item Store
      if(e.store == '' && e.initialQty > 0) {
        e.errID.push(11);
        e.errors.push({ errID: 11, errorMsg: 'Please select a store.' });
      }
      else {
        if(e.store == '' && !e.initialQty) {
          e.storeID = 0;
        }
        else {
          isCheckDup = [];
          isCheckDup = this.storeList.filter((x:any)=>x.sNm.toLowerCase() == e.store.toLowerCase());
          if(isCheckDup.length == 0) {
            e.errID.push(11);
            e.errors.push({ errID: 11, errorMsg: 'Please select a valid store.' });
          }
          else {
            e.storeID = isCheckDup[0].StrID;
            e.store = isCheckDup[0].sNm;
          }
        }        
      }
  
      //Item Category & SubCat
      
      let isValidCtg = $.grep(itemCategories, function(o: any){ return o.cnm.toLowerCase() == e.category.toLowerCase()});
      if(!e.category || isValidCtg.length == 0) {
        e.errID.push(3);
        e.errors.push({ errID: 3, errorMsg: 'Please select a valid category.' });
      }
      else {
        e.CID = isValidCtg[0].cid;
        // for Sub-Category Validation
        if(isValidCtg[0].sub) {
          if(e.subCategory == '') {
            e.errID.push(4);
            e.errors.push({ errID: 4, errorMsg: 'Please select a valid sub-category.' });
          }
          else {
            let subCategory = isValidCtg[0].sub;
            let isValidSubCtg = $.grep(subCategory, function(o: any){ return o.snm.toLowerCase() == e.subCategory.toLowerCase()});
            if(isCheckDup.length > 0){
              e.SCID = isValidSubCtg[0].sid;
            }
            else {
              e.errID.push(4);
              e.errors.push({ errID: 4, errorMsg: 'Please select a valid sub-category.' });
            }
          }        
        }
        else {
          e.errID.push(4);
          e.errors.push({ errID: 4, errorMsg: 'Please select a valid sub-category.' });
        }
      }

      if(e.gst == "undefined" || e.gst == null || isNaN(e.gst)) {
        e.errID.push(13);
        e.errors.push({ errID: 13, errorMsg: 'Please enter the GST rate.' });
      }
      else {
        if(!e.hsn && e.gst > 0) {
          e.errID.push(12);
          e.errors.push({ errID: 12, errorMsg: 'Please enter the HSN/SAC.' });
        }
      }
    
      e.HSNID = 0;
      if(e.hsn) {
        let isValidHSN = $.grep(hsnList, function(o: any){ return o.H == String(e.hsn).trim()} );
        if(isValidHSN.length > 0) {
          e.HSNID = isValidHSN[0].HID;
          e.gst = isValidHSN[0].Per;
        }
      }

      //Item Unit List
      if(e.unit == '') {
        e.errID.push(10);
        e.errors.push({ errID: 10, errorMsg: 'Please select a unit.' });
      }
      else {
        let isValidUnit = $.grep(this.unitList, function(o: any){ return o.UNm == e.unit});
        if(isValidUnit.length == 0) {
          e.errID.push(10);
          e.errors.push({ errID: 10, errorMsg: 'Please select a valid unit.' });
        }  
      }

      // Std Cost
      if(e.stdCost == "undefined" || e.stdCost == null || isNaN(e.stdCost) || e.stdCost < 0) {
        e.errID.push(6);
        e.errors.push({ errID: 6, errorMsg: 'Please enter a valid std cost.' });
      }

      // Purch Cost
      if(e.purchCost == "undefined" || e.purchCost == null || isNaN(e.purchCost) || e.purchCost < 0) {
        e.errID.push(7);
        e.errors.push({ errID: 7, errorMsg: 'Please enter a valid purch price.' });
      }

      // Std Sale Price
      if(e.stdSalePrice == "undefined" || e.stdSalePrice == null || isNaN(e.stdSalePrice) || e.stdSalePrice < 0) {
        e.errID.push(8);
        e.errors.push({ errID: 8, errorMsg: 'Please enter a valid std sale price.' });
      }

      //Item Initial Qty 
      if(e.initialQty == "undefined" || e.initialQty == null || isNaN(e.initialQty) || e.initialQty < 0) {
        e.errID.push(9);
        e.errors.push({ errID: 9, errorMsg: 'Please enter a valid initial item quantity.' });
      }
      else if(accountFinYear != currFinYear && e.initialQty > 0) {
        e.errID.push(9);
        e.errors.push({ errID: 9, errorMsg: 'Initial quantity cannot be entered after the first financial year.' });
      }
      else if(e.initialQty > 0) {
        let selectedUnit = $.grep(this.unitList, function(o: any){ return o.UNm == e.unit});
        if(selectedUnit.length > 0) {
          let precisonNum = selectedUnit[0].Prcsn;
          let initialQtyPrcsn = String(e.initialQty).split(".");
          if(initialQtyPrcsn.length > 1) {
            let selectedPrcn = String(initialQtyPrcsn[1]).length;
            if(precisonNum < selectedPrcn && selectedPrcn > 0) {
              e.errID.push(9);
              e.errors.push({ errID: 9, errorMsg: 'Initial quantity precision do not match with unit precision.' });
            }
          }
        }
      }
    
      //Type
      if(e.type == '') {
        e.errID.push(5);
        e.errors.push({ errID: 5, errorMsg: 'Please select a valid type.' });
      }
      else {
        let isValidItemType = $.grep(itemType, (o: any) => { return o.type == e.type});
        if(isValidItemType.length == 0) {
          e.errID.push(5);
          e.errors.push({ errID: 5, errorMsg: 'Please select a valid type.' });
        }
        else {
          e.typeID = isValidItemType[0].id;
        }
      }

      //Source
      if(e.source) {
        let isValidItemSource = $.grep(purchaseTypes, (o: any) => { return o.type == e.source});
        if(isValidItemSource.length == 0) {
          e.errID.push(15);
          e.errors.push({ errID: 15, errorMsg: 'Please enter a valid sourcing method.' });
        }
        else {
          e.purchageTypeID = isValidItemSource[0].id;
        }
      }
      
      //Description
      if(e.desc){
        if(e.desc.length > 300) {
          e.errID.push(14);
          e.errors.push({ errID: 14, errorMsg: 'Please enter a description shorter than 300 characters.' });
        }    
      }
      
      //Lead Time
      if(e.leadTime == "undefined" || e.leadTime == null || isNaN(e.leadTime) || e.leadTime < 0) {
        e.errID.push(16);
        e.errors.push({ errID: 16, errorMsg: 'Please enter a valid lead time.' });
      }

      //Minimum Stock
      if(e.minStock == "undefined" || e.minStock == null || isNaN(e.minStock) || e.minStock < 0) {
        e.errID.push(17);
        e.errors.push({ errID: 17, errorMsg: 'Please enter a valid minimum stock quantity.' });
      }
      //MRP Price
      if(e.mrpPrice == "undefined" || e.mrpPrice == null || isNaN(e.mrpPrice) || e.mrpPrice < 0) {
        e.errID.push(18);
        e.errors.push({ errID: 18, errorMsg: 'Please enter a valid MRP Price' });
      }
    });

    for(let i: number = 0; i < itmArraylength; i++) {
      if(items[i].errors != ''){
        errorList.push({
          errID: items[i].errID,
          errors: items[i].errors,
        });
      }
    }
    this.itemErrors = errorList;
  }

  //saveBulkItems() - Add excel data into database
  saveBulkItems(){
    let finalItemArry:Array<any> = [];
    if(this.error.ignoreErrors) {
      this.itemParamList.forEach(function (e: any) {  
        
        let DefStockRate: String = ((!e.stdCost || e.stdCost == 0) ? 0 : String(e.stdCost).trim()) + "";
        let DefPurchRate: String = ((!e.purchCost || e.purchCost == 0) ? DefStockRate : String(e.purchCost).trim()) + "";
        let DefSaleRate: string = ((!e.stdSalePrice || e.stdSalePrice  == 0) ? DefStockRate : String(e.stdSalePrice).trim()) + "";
        
          finalItemArry.push({
            'ItemID': 0,
            'ItemName': String(e.itemName).trim(),
            'ItemCode': String(e.itemCode).trim(),        
            'Details': String(e.desc).trim() ? String(e.desc).trim() : '',
            'TypeID': String(e.typeID).trim(),
            'CategoryID': String(e.CID).trim(),
            'SubCategoryID': String(e.SCID).trim(),
            'ISMade': (e.purchageTypeID == 1 || e.purchageTypeID == 3) ? 1 : 0,
            'IsPurchased': (e.purchageTypeID == 2 || e.purchageTypeID == 3) ? 1 : 0,      
            'CurrQty': String(e.initialQty).trim() + "",
            'CurrStoreID': String(e.storeID).trim(),
            'SKU': String(e.unit).trim(),
            'storeBatches': '',
            'DefPurchRate': String(DefPurchRate),
            'DefSaleRate': String(DefSaleRate),
            'DefStockRate': String(DefStockRate),
            'MinStockQty': (!String(e.minStock).trim() ? '0' : String(e.minStock).trim()),
            'IsAvailable': 1,
            'IsActive': 1,
            'ImportanceID': 1,
            'HSNID': e.HSNID,
            'ShowOnline': 1,
            'BrochureLink': '',
            'photos': '',
            'Tags': '',
            'LeadTime': (!String(e.leadTime).trim() ? '0' : String(e.leadTime).trim()),
            'HsnNo': (!String(e.hsn).trim() ? '0' : String(e.hsn).trim()),
            'IGSTRate': (!String(e.gst).trim() ? '0' : String(e.gst).trim()),
            'InternalNotes': '',
            'MRPPrice': (!String(e.mrpPrice).trim() ? '0' : String(e.mrpPrice).trim())
          });
      });
    }
    
    if(finalItemArry.length == 0) {
      this.apiService.successAlert("No data found.");
      return;
    }

    let itemCnt = finalItemArry.length;
    
    let isAllowConfirm = confirm("Are you sure you want to import " + itemCnt + " " + (itemCnt > 1 ? 'items' : 'item') + " ?");
    if(!isAllowConfirm) {
      return;
    }  

    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT")

    let data = [{
        data: JSON.stringify(finalItemArry)
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'importItems',
      moduleID: 5,
      data: JSON.stringify(data)
    }];

    this.apiService.sendChangeForm(myParams, this.successItemEntry.bind(this), this.failureResp.bind(this));
  }

    //successVchrEntry - success voucher entry handler
  successItemEntry(res: any) {
    this.error.apiResponse = true;
    if (res.error) {
    }
    else {
      this.itemList = [];
      let errorList: Array<any> = [];
      if (res.updatePackage) {
        let result: any = JSON.parse(res.updatePackage);
        let returnItems = result.Table1;
        if(returnItems.length > 0) {
          for(let i: number = 0; i < returnItems.length; i++) {
            if (returnItems[i].errors != '' || returnItems[i].ErrorMsg != '') {
              errorList.push({
                srNo: i + 1,
                itemName: returnItems[i].ItemName,
                errors: returnItems[i].ErrorMsg ? returnItems[i].ErrorMsg : returnItems[i].errors  
              });
            }
          }
          this.error.showError = true;
          this.error.ignoreErrors = false;
          this.itemList = errorList;
          if (this.itemList.length > 0) {
            // this.apiService.successAlert('Some items cannot be imported.');
            this.apiService.successAlert('Some items cannot be imported.  ' + this.itemList[0].errors);
          }
        }
        else {
          this.apiService.successAlert('Items imported.');
          localStorage.removeItem('importItems');
          this.openStockPage();
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  validateField(type: String, index: number) {
    this.itemParamList =  this.itemList;
    let e = this.itemParamList[index];
    let isCheckDup = [];
    let itemType: Array<any> = this.itemType;
    let purchaseTypes: Array<any> = this.purchaseTypes;

    //Cat-Sub Cat List
    let itemCategories: Array<any> = [];
    itemCategories = JSON.parse(this.itemCategories);

    let accountFinYear = this.CmnService.getCurrentFinancialYear(this.acctStartDT);
    let currFinYear = this.CmnService.getCurrentFinancialYear(new Date);

    //check if the value exists
    e.itemName = e.itemName || '';
    e.itemCode = e.itemCode || '';
    e.category = e.category || '';
    e.type = e.type || '';
    e.initialQty = e.initialQty || 0;
    e.unit = e.unit || '';
    e.store = e.store || '';

    //Trim all the values
    e.itemName = String(e.itemName).trim();
    e.itemCode = String(e.itemCode).trim();
    e.store = String(e.store).trim();
    e.category = String(e.category).trim();
    e.unit = String(e.unit).trim();
    e.type = String(e.type).trim();

    switch (type) {
      case 'itemName':
        e.errors = e.errors.filter((error: any) => error.errID != 1);
        e.errID = e.errID.filter((id: number) => id != 1);

        if(e.itemName == '') {
          e.errID.push(1);
          e.errors.push({ errID: 1, errorMsg: 'Please enter an item name.' });
        }
        else if (e.itemName.length > 100) {
          e.errID.push(1);
          e.errors.push({ errID: 1, errorMsg: 'Please enter item name shorter than 100 characters.' });
        }
        else {
          //Item Name Duplications in Excel
          isCheckDup = $.grep(this.itemParamList, function(o: any) { return o.itemName == e.itemName });
          if(isCheckDup.length > 1) {
              e.errID.push(1);
              e.errors.push({ errID: 1, errorMsg: 'Duplicate item name in uploaded sheet.' });
          }
          else {
            // Check Duplicate item in item List
            let isDup = this.itemData.filter((x: any) => x.ItemName == e.itemName)
            if(isDup.length > 0) {
              e.errID.push(1);
              e.errors.push({ errID: 1, errorMsg: 'Another item with this name already exists.' });
            }
          }                
        }
        break;
      
      case 'itemCode':
        e.errors = e.errors.filter((error: any) => error.errID != 2);
        e.errID = e.errID.filter((id: number) => id != 2);

        if(e.itemCode == '') {
          e.errID.push(2);
          e.errors.push({ errID: 2, errorMsg: 'Please enter an item code.' });
        }
        else if (e.itemCode.length > 50) {
          e.errID.push(2);
          e.errors.push({ errID: 2, errorMsg: 'Please enter item code shorter than 50 characters.' });
        }
        else{
          isCheckDup = [];
          isCheckDup = $.grep(this.itemParamList, function(o: any) { return o.itemCode == e.itemCode });
          if(isCheckDup.length > 1){
              e.errID.push(2);
              e.errors.push({ errID: 2, errorMsg: 'Duplicate item code in uploaded sheet.' });
          }
          else{
            // Check Duplicate item code in item List
            let isDup = this.itemData.filter((x: any) => x.ItemCode == e.itemCode)
            if(isDup.length > 0) {
              e.errID.push(2);
              e.errors.push({ errID: 2, errorMsg: 'Another item with this code already exists.' });
            }
          }         
        }
        break;

      case 'category':
        e.errors = e.errors.filter((error: any) => error.errID != 3);
        e.errID = e.errID.filter((id: number) => id != 3);
        e.errors = e.errors.filter((error: any) => error.errID != 4);
        e.errID = e.errID.filter((id: number) => id != 4);

        let isValidCtg = $.grep(itemCategories, function(o: any){ return o.cnm.toLowerCase() == e.category.toLowerCase()});
        if(isValidCtg.length == 0) {
          e.errID.push(3);
          e.errors.push({ errID: 3, errorMsg: 'Please select valid category.' });
        }
        else {
          e.CID = isValidCtg[0].cid;
          e.category = isValidCtg[0].cnm;
          
          // for Sub-Category Validation
          if(isValidCtg[0].sub) {
            if(e.origSubCtg == '') {
              e.errID.push(4);
              e.errors.push({ errID: 4, errorMsg: 'Please select a valid sub-category.' });
            }
            else {
              let subCategory = isValidCtg[0].sub;
              let isValidSubCtg = $.grep(subCategory, function(o: any){ return o.snm.toLowerCase() == e.origSubCtg.toLowerCase()});
              if(isValidSubCtg.length == 0){
                e.errID.push(4);
                e.errors.push({ errID: 4, errorMsg: 'Please select a valid sub-category.' });
              }
              else {
                e.SCID = isValidSubCtg[0].sid;
                e.subCategory = isValidSubCtg[0].snm;
              }
            }        
          }
          else {
            e.errID.push(4);
            e.errors.push({ errID: 4, errorMsg: 'Please select a valid sub-category.' });
          }
        }
        break;

      case 'subCategory':
        if (e.CID) {
          e.errors = e.errors.filter((error: any) => error.errID != 4);
          e.errID = e.errID.filter((id: number) => id != 4);
        }

        let checkIfValidCtg = $.grep(itemCategories, function(o: any){ return o.cnm.toLowerCase() == e.category.toLowerCase()});

        if (checkIfValidCtg.length == 0) {
          e.errID.push(4);
          e.errors.push({ errID: 4, errorMsg: 'Please select a valid sub-category.' });
        }
        else {
          // for Sub-Category Validation
          let currSubCtg = checkIfValidCtg[0].sub;
          if(e.subCategory == '') {
            e.errID.push(4);
            e.errors.push({ errID: 4, errorMsg: 'Please select a valid sub-category.' });
          }
          else {
            let isValidSubCtg = $.grep(currSubCtg, function(o: any){ return o.snm.toLowerCase() == e.subCategory.toLowerCase()});
            if(isValidSubCtg.length == 0){
              e.errID.push(4);
              e.errors.push({ errID: 4, errorMsg: 'Please select a valid sub-category.' });
            }
            else {
              e.SCID = isValidSubCtg[0].sid;
              e.subCategory = isValidSubCtg[0].snm;
            }
          }
        }
        break;

      case 'type':
        e.errors = e.errors.filter((error: any) => error.errID != 5);
        e.errID = e.errID.filter((id: number) => id != 5);

          //Type
        if(e.type == '') {
          e.errID.push(5);
          e.errors.push({ errID: 5, errorMsg: 'Please enter a valid type.' });
        }
        else {
          let isValidItemType = $.grep(itemType, (o: any) => { return o.type == e.type});
          if(isValidItemType.length == 0) {
            e.errID.push(5);
            e.errors.push({ errID: 5, errorMsg: 'Please enter a valid type.' });
          }
          else {
            e.typeID = isValidItemType[0].id;
          }
        }
        break;

      case 'stdCost':
        e.errors = e.errors.filter((error: any) => error.errID != 6);
        e.errID = e.errID.filter((id: number) => id != 6);

        // Std Cost
        if(e.stdCost == "undefined" || e.stdCost == null || isNaN(e.stdCost) || e.stdCost < 0) {
          e.errID.push(6);
          e.errors.push({ errID: 6, errorMsg: 'Please enter a valid standard cost.' });  
        }
        break;

      case 'purchCost':
        e.errors = e.errors.filter((error: any) => error.errID != 7);
        e.errID = e.errID.filter((id: number) => id != 7);

        // Purch Cost
        if(e.purchCost == "undefined" || e.purchCost == null || isNaN(e.purchCost) || e.purchCost < 0) {
          e.errID.push(7);
          e.errors.push({ errID: 7, errorMsg: 'Please enter a valid purchase cost.' });  
        }
        break;
      case 'stdSalePrice':
        e.errors = e.errors.filter((error: any) => error.errID != 8);
        e.errID = e.errID.filter((id: number) => id != 8);

        // Std Sale Price
        if(e.stdSalePrice == "undefined" || e.stdSalePrice == null || isNaN(e.stdSalePrice) || e.stdSalePrice < 0) {
          e.errID.push(8);
          e.errors.push({ errID: 8, errorMsg: 'Please enter a valid standard sale price.' });  
        }
        break;
      case 'initialQty':
        e.errors = e.errors.filter((error: any) => error.errID != 9);
        e.errID = e.errID.filter((id: number) => id != 9);

        //Item Initial Qty 
        if(e.initialQty == "undefined" || e.initialQty == null || isNaN(e.initialQty) || e.initialQty < 0) {
          e.errID.push(9);
          e.errors.push({ errID: 9, errorMsg: 'Please enter a valid initial item quantity.' });
        }
        else if(accountFinYear != currFinYear && e.initialQty > 0) {
          e.errID.push(9);
          e.errors.push({ errID: 9, errorMsg: 'Initial quantity cannot be entered after the first financial year.' });
        }
        else if(e.initialQty > 0) {
          let selectedUnit = $.grep(this.unitList, function(o: any){ return o.UNm == e.unit});
          if(selectedUnit.length > 0) {
            let precisonNum = selectedUnit[0].Prcsn;
            let initialQtyPrcsn = String(e.initialQty).split(".");
            if(initialQtyPrcsn.length > 1) {
              let selectedPrcn = String(initialQtyPrcsn[1]).length;
              if(precisonNum < selectedPrcn && selectedPrcn > 0) {
                e.errID.push(9);
                e.errors.push({ errID: 9, errorMsg: 'Initial quantity precision do not match with unit precision.' });
              }
            }
          }
        }
        break;

      case 'unit':
        e.errors = e.errors.filter((error: any) => error.errID != 10);
        e.errID = e.errID.filter((id: number) => id != 10);

        //Item Unit List
        if(e.unit == '') {
          e.errID.push(10);
          e.errors.push({ errID: 10, errorMsg: 'Please enter a unit.' });
        }
        else {
          let isValidUnit = $.grep(this.unitList, function(o: any){ return o.UNm == e.unit});
          if(isValidUnit.length == 0) {
            e.errID.push(10);
            e.errors.push({ errID: 10, errorMsg: 'Please enter a valid unit.' });
          }  
        }
        break;      
      
      case 'store':
        e.errors = e.errors.filter((error: any) => error.errID != 11);
        e.errID = e.errID.filter((id: number) => id != 11);

        //Item Store
        if(e.store == '' && e.initialQty > 0) {
          e.errID.push(11);
          e.errors.push({ errID: 11, errorMsg: 'Please enter a store.' });
        }
        else {
          if(e.store == '' && !e.initialQty) {
            e.storeID = 0;
          }
          else {
            isCheckDup = [];
            isCheckDup = this.storeList.filter((x:any)=>x.sNm.toLowerCase() == e.store.toLowerCase());
            if(isCheckDup.length == 0) {
              e.errID.push(11);
              e.errors.push({ errID: 11, errorMsg: 'Please enter a valid store.' });
            }
            else {
              e.storeID = isCheckDup[0].StrID;
              e.store = isCheckDup[0].sNm;
            }
          }        
        }
        break; 

      case 'hsn':
        e.errors = e.errors.filter((error: any) => error.errID != 12);
        e.errID = e.errID.filter((id: number) => id != 12);

        // HSN
        if(e.gst) {
          if(!e.hsn && e.gst > 0) {
            e.errID.push(12);
            e.errors.push({ errID: 12, errorMsg: 'Please enter the HSN/SAC.' });
          }
        }
        break;
      case 'gst':
        e.errors = e.errors.filter((error: any) => error.errID != 13);
        e.errID = e.errID.filter((id: number) => id != 13);
        e.errors = e.errors.filter((error: any) => error.errID != 12);
        e.errID = e.errID.filter((id: number) => id != 12);
        if(e.gst == "undefined" || e.gst == null || isNaN(e.gst)) {
          e.errID.push(13);
          e.errors.push({ errID: 13, errorMsg: 'Please enter the GST rate.' });
          
        }
        if(e.gst && !e.hsn) {
          e.errID.push(12);
          e.errors.push({ errID: 12, errorMsg: 'Please enter the HSN/SAC.' });
        }
        break;
      case 'desc':
        e.errors = e.errors.filter((error: any) => error.errID != 14);
        e.errID = e.errID.filter((id: number) => id != 14);

        if(e.desc){
          if(e.desc.length > 300) {
            e.errID.push(14);
            e.errors.push({ errID: 14, errorMsg: 'Please enter a description shorter than 300 characters.' });
          }    
        }
        break;
      case 'source':
        e.errors = e.errors.filter((error: any) => error.errID != 15);
        e.errID = e.errID.filter((id: number) => id != 15);

        //Source
        if(e.source) {
          let isValidItemSource = $.grep(purchaseTypes, (o: any) => { return o.type == e.source});
          if(isValidItemSource.length == 0) {
            e.errID.push(15);
            e.errors.push({ errID: 15, errorMsg: 'Please enter a valid sourcing method.' });
          }
          else {
            e.purchageTypeID = isValidItemSource[0].id;
          }
        }
        break;
      case 'leadTime':
        e.errors = e.errors.filter((error: any) => error.errID != 16);
        e.errID = e.errID.filter((id: number) => id != 16);

        //Lead Time
        if(e.leadTime == "undefined" || e.leadTime == null || isNaN(e.leadTime) || e.leadTime < 0) {
          e.errID.push(16);
          e.errors.push({ errID: 16, errorMsg: 'Please enter a valid lead time.' });
        }
        break;
      case 'minStock':
        e.errors = e.errors.filter((error: any) => error.errID != 17);
        e.errID = e.errID.filter((id: number) => id != 17);

        //Minimum Stock
        if(e.minStock == "undefined" || e.minStock == null || isNaN(e.minStock) || e.minStock < 0) {
          e.errID.push(17);
          e.errors.push({ errID: 17, errorMsg: 'Please enter a valid minimum stock quantity.' });
        }
        break;
      case 'mrpPrice':
        e.errors = e.errors.filter((error: any) => error.errID != 18);
        e.errID = e.errID.filter((id: number) => id != 18);

        //Source
        if(e.mrpPrice == "undefined" || e.mrpPrice == null || isNaN(e.mrpPrice) || e.mrpPrice < 0) {
          e.errID.push(18);
          e.errors.push({ errID: 18, errorMsg: 'Please enter a valid MRP Price.' });  
        }
        break;
      default:
        break;
    }
  }

  openStockPage() {  
    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP";
    }
    urlCheck += "/Stock"; 
    
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    window.open(urlCheck, target);
  }

}
